<template>
  <div class="files-lookup">
    <div
      class="files-lookup__button"
      @click.stop="lookupFile = true">
      <span class="files-lookup__button-text">Search</span>
      <em
        translate="no"
        class="material-icons notranslate">
        search
      </em>
    </div>
    <vs-popup
      title="Search a file"
      color="primary"
      :active.sync="lookupFile"
      class="file-lookup-popup"
    >
        <div class="files-lookup__list-current-files border-0 border-b border-solid border-grey-light pb-10">
          <h5>Currently selected:</h5>
          <ul v-if="files && files.length" class="files-lookup__list pl-10 mt-10">
            <li class="mb-3" v-for="file in files" :key="file.id">
              {{ file.name }}
              <feather-icon
                @click.stop="$emit('file-deleted', file)"
                icon="Trash2Icon"
                svgClasses="h-5 w-5 color-current text-danger"
                class="cursor-pointer ml-5 align-text-bottom"
              />
            </li>
          </ul>
          <span v-else class="text-center">No files have been selected</span>
        </div>
        <div class="files-lookup__form pt-10">
          <label>Search files from other courses</label>
          <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0" v-if="lookupFile">
            <vs-input v-model="name" @keyup.enter.native="searchContent"></vs-input>
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button @click="searchContent">Search</vs-button>
              </div>
            </template>
          </vx-input-group>
            <div class="file-in-courses courses-data vs-con-loading__container">
              <template>
                <div class="search-async-api-data vs-con-loading__container">
                  <vs-table-m
                    :sst="true"
                    :total="totalItems"
                    :maxItems="pageSize"
                    :data="items"
                    :emitWhenOpenRow="true"
                    :showExpandableData="true"
                    class="mt-10"
                    @change-page="handleChangePage"
                    @selected="toggleRow"
                    pagination
                    stripe
                  >
                    <template slot="header">
                      <div class="flex items-center w-full">
                        <h4 class="m-2 my-4">
                          Course list
                        </h4>
                        <div class="ml-auto mr-6 text-lg font-semibold">
                          {{totalItems}} results
                        </div>
                      </div>
                      
                    </template>
                    <template slot="thead">
                      <vs-th sort-key="name">
                        Name
                      </vs-th>
                      <vs-th sort-key="status">
                        Status
                      </vs-th>
                      <vs-th sort-key="numberOfFiles">
                        Number of files
                      </vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <template v-for="(tr, indextr) in data">
                        <vs-tr :data="tr" :key="indextr">

                          <vs-td :data="tr.name">
                            {{tr.name}}
                          </vs-td>

                          <vs-td :data="tr.status">
                            {{tr.status}}
                          </vs-td>

                          <vs-td :data="tr.status">
                            {{ filesInContent(tr) }}
                          </vs-td>
                          
                        </vs-tr>
                        <ContentFiles
                          v-if="rowsOpened.includes(tr.id)"
                          :key="`${indextr}-expanded`"
                          :numberOfCols="3"
                          :filesData="filesFromCourses[tr.id]"
                          :loading="rowsLoading.includes(tr.id)"
                          :filesSelected="filesSelected"
                          @file-added="$emit('file-added', $event)"
                        />
                      </template>
                    </template>
                  </vs-table-m>
                </div>
              </template>
            </div>
        </div>
     </vs-popup>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import VsTableM from '@/components/VsTableM'
import ContentFiles from './ContentFiles.vue'
export default {
  props: {
    files: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      required: false,
      default: () => {
        return 'course'
      }
    },
  },
  components: {
    ContentFiles,
    VsTableM
  },
  data: () => {
    return {
      lookupFile: false,
      name: '',
      items: [],
      totalItems: 0,
      pageSize: 20,
      rowsOpened: [],
      rowsLoading: [],
      page: 1,
      filesFromCourses: {}
    }
  },
  computed: {
    courseContent() {
      return this.type === 'course'
    },
    filesSelected() {
      return this.files.map(f => f.id)
    }
  },
  methods: {
    ...mapActions('files', ['getAllFiles']),
    ...mapActions('courses', ['searchCourses']),
    filesInContent(content) {
      if (this.courseContent) {
        return content.files_uuids.length
      } else {
        return content.files.length
      }
    },
    handleChangePage(page) {
      this.page = page
      this.searchContent({
        page: this.page.toString(),
        ordering: this.ordering
      })
    },
    async searchContent (payload = {}) {
      if (!this.name) return

      this.$vs.loading({
        container: '.search-async-api-data',
        scale: 0.6
      })

      payload.name__icontains = this.name
      payload.page_size = this.pageSize.toString()

      try {
        const response = await this.searchCourses(payload)
        this.items = response.results
        this.totalItems = response.count
      } catch (error) {
        this.$vs.loading.close('.search-async-api-data > .con-vs-loading')
        this.showError(error)
      }
      this.$vs.loading.close('.search-async-api-data > .con-vs-loading')
    },
    async toggleRow(row) {
      if (this.rowsOpened.includes(row.id)) {
        // close the row
        const index = this.rowsOpened.indexOf(row.id)
        if (index > -1) {
          this.rowsOpened.splice(index, 1)
        }
        return
      }
      this.rowsLoading.push(row.id)
      this.rowsOpened.push(row.id)
      try {
        // Get files of the selected content

        // ToDo: make this a generic computed prop
        const filesUUIDs = row.files_uuids || []
        if (filesUUIDs.length) {
          const response = await this.getAllFiles({
            ids: filesUUIDs
          })
          this.$set(this.filesFromCourses, row.id, {
            count: response.count,
            results: response.results
          })
        }
      } catch (error) {
        this.showError(error)
      }
      
      await this.$nextTick()
      const index = this.rowsLoading.indexOf(row.id)
      if (index > -1) {
        this.rowsLoading.splice(index, 1)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.files-lookup {
  &__button {
    background: #f5f5f5;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
    transition: all .25s ease;
    border: 1px dashed rgba(0,0,0,.1);
    height: 80px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    cursor: pointer;
  }
  &__button-text {
    padding-top: 20px;
    font-weight: bold;
    width: 100%;
    text-align: center;
  }
  &__list {
    list-style-type: disc;
  }
}
</style>